import { render, staticRenderFns } from "./AccountantsSettingsMenu.vue?vue&type=template&id=30f0bcbd&scoped=true&"
import script from "./AccountantsSettingsMenu.vue?vue&type=script&lang=js&"
export * from "./AccountantsSettingsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f0bcbd",
  null
  
)

export default component.exports